import React from "react";
import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {useShiftRequest} from "./useShiftRequest";
import {Container, FormHeader} from "./ShiftRequest.styles";
import {ShiftRequestCalendar} from "./shiftRequestCalendar/ShiftRequestCalendar";
import {ShiftRequestHeader} from "./shiftRequestHeader/ShiftRequestHeader";
import {ShiftRequestModal} from "./shiftRequestModal/ShiftRequestModal";

export const ShiftRequestContext = React.createContext();
export const ShiftRequest = () => {
    const {t} = useTranslation();
    const shiftRequestContext = useShiftRequest();

    return useObserver(() => (
        <ShiftRequestContext.Provider value={shiftRequestContext}>
            <Container data-testid="shiftRequest" gutter={[20, 20]}>
                <FormHeader>{t("screens.shiftRequest", {ns: "common"})}</FormHeader>
                <ShiftRequestHeader />
                <ShiftRequestCalendar />
                <ShiftRequestModal />
            </Container>
        </ShiftRequestContext.Provider>
    ));
};
